import { render, staticRenderFns } from "./CsatTable.vue?vue&type=template&id=01cb5228&scoped=true&"
import script from "./CsatTable.vue?vue&type=script&lang=js&"
export * from "./CsatTable.vue?vue&type=script&lang=js&"
import style0 from "./CsatTable.vue?vue&type=style&index=0&id=01cb5228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb5228",
  null
  
)

export default component.exports